<template>
  <div class="home">
    <div class="page-left">
      <date-com class="date"></date-com>
      <div :class="['btn-list-select btn-recommended', {active: listType == 1}]" @click="listType = 1">{{ T('Featured') }}</div>
      <div :class="['btn-list-select btn-new', {active: listType == 2}]" @click="listType = 2">{{ T('NEW') }}</div>
      <div class="btn-view" @click="showRecruitDialog">{{ T('Quick_Recruit') }}</div>
    </div>
    <div class="page-right">
      <div class="top">
        <div class="lang-btn" @click="showLangDialog"><span>{{ lang | uppercase }}</span></div>
        <div class="login-btn" v-if="!hasLogin" @click="showLogin"><span>{{ T('Login') }}</span></div>
        <div class="haslogin" v-else-if="!isWebview">
          <selector ref="roleList" class="selector-item" :options="roleList" v-model="roleInfo" :title="T('Account')"></selector>
          <div class="logout" @click="logout">{{ T('Switch_Account') }}</div>
        </div>
        <div class="haslogin webview-userinfo" v-else>
          <p>{{ userInfo.server_name }} - {{ userInfo.role_name }}</p>
        </div>
      </div>
      <div class="banner"></div>
      <div class="content" ref="content">
          <keep-alive>
            <router-view name="list"></router-view>
          </keep-alive>
          <router-view></router-view>
      </div>
    </div>
    <Dialog ref="dialog" :title="dialog.title">
      <!-- 语言选择 -->
      <div class="dialog-lang" v-if="dialog.type === 'lang'">
        <div class="lang-content">
          <ScrollSelect :selectArr="langArr" :selecKey.sync="nowLang" @change="changeSelectLang"></ScrollSelect>
        </div>
        <div class="lang-btn">
          <a class="lang-confilm" @click="langConfilm">{{ T('确认') }}</a>
        </div>
      </div>
      <!-- 快速征募 -->
      <div class="dialog-recruit" v-if="dialog.type === 'recruit'">
        <div class="recruit-content" v-if="unionInfo">
          <div class="main-info">
            <div class="flag">
              <flag width="124" :flagStyle="{bg: unionInfo.bg_id, edgings: unionInfo.edgings_id, pattern: unionInfo.pattern_id}"></flag>
            </div>
            <div class="info-wrap text-shadow">
              <div class="name-row">
                <span :class="['nick-name', {green: unionInfo.county.toUpperCase() == 'SHU', red: unionInfo.county.toUpperCase() == 'WUU', blue: unionInfo.county.toUpperCase() == 'WEI'}]">[{{unionInfo.legion_nick_name || T('None')}}]</span>
                <span class="name">{{ unionInfo.legion_name | name }}</span>
              </div>
              <div class="lv-row">
                <span class="name">{{ T('Alliance_Level') }}：Lv.{{ unionInfo.level }}</span>
                <span class="name">[{{ unionInfo.world_name || T('None') }}]</span>
              </div>
            </div>
          </div>
          <div class="info">
            <div class="addition">
              <div class="text-shadow">{{ T('Alliance_Power') }}</div>
              <div class="text-shadow">{{ unionInfo.power | thousandBitSeparator }}</div>
            </div>
            <div class="addition">
              <div class="text-shadow">{{ T('Alliance_Faction_Power') }}</div>
              <div class="text-shadow">{{ unionInfo.influence | thousandBitSeparator }}</div>
            </div>
            <div class="addition">
              <div class="text-shadow">{{ T('Members') }}</div>
              <div class="text-shadow">{{ unionInfo.member_count | thousandBitSeparator}}</div>
            </div>
            <div class="addition">
              <div class="text-shadow">{{ T('Language') }}</div>
              <div class="text-shadow">{{ unionInfo.language_id | language }}</div>
            </div>
          </div>
          <div class="declar">
            <div class="title">{{ T('Declaration') }}</div>
            <div class="notice">{{ unionInfo.notice }}</div>
          </div>
        </div>
        <div class="recruit-btn">
          <a class="recruit-confilm" @click="recruitConfilm">{{ T('Post') }}</a>
        </div>
      </div>
      <!-- 登录 -->
      <login v-if="dialog.type === 'login'" @login="onlogin"/>
      <!-- 错误信息 -->
      <div class="dialog-error" v-if="dialog.type === 'toast'">
        {{ T(dialog.text) }}
      </div>
    </Dialog>
  </div>
</template>

<script>
// 首页
import dateCom from "@/components/DateCom";
import selector from "@/components/Selector";
import Dialog from "@/components/Dialog";
import ScrollSelect from "@/components/ScrollSelect";
import login from "@/components/Login"
import flag from '@/components/UnionFlag'
import { postUnion } from "@/common/api";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      listType: 1,
      roleInfo: '0',

      dialog: {
        type: null,
        title: null
      },
      nowLang: ''
    };
  },
  components: {
    dateCom,
    selector,
    Dialog,
    ScrollSelect,
    login,
    flag
  },
  watch: {
    listType: {
      handler(newVal) {
        if (!this.$route.query?.f) {
          // 如果路径未带值
          this.$router.push({
            path: '/',
            query: {
              f: window.btoa(JSON.stringify({t: newVal}))
            }
          })
        } else {
          // 如果带有筛选值
          let f = JSON.parse(window.atob(decodeURIComponent(this.$route.query.f)))
          f.t = newVal
          this.$router.push({
            path: '/',
            query: {
              f: window.btoa(JSON.stringify(f))
            }
          })
        }
      }
    },
    lang: {
      handler(newVal) {
        this.nowLang = newVal
      },
      immediate: true
    },
    roleInfo: {
      handler(newVal) {
        // 选择的角色
        if (this.hasLogin) {
          let [serverId, roleId] = newVal.split('|')
          this.$store.dispatch('upDateUnion', {serverId, roleId})
        }
      },
      immediate: false
    },
    roleList: {
      handler(newVal) {
        if (newVal.length) {
          this.$set(this, 'roleInfo', newVal[0].key)
          // this.roleInfo = newVal[0].key

          /*若要进入就弹窗选角色 则放开注释*/
          // this.$nextTick(function() {
          //   if (Object.keys(this.userInfo).length == 0) {
          //     // 如果没有选择角色
          //     if (this.$refs.roleList) {
          //       this.$refs.roleList.open()
          //     }
          //   }
          // })
        }
      },
      immediate: true
    }
  },
  mounted() {
    // this.$Spinner.showLoading(this.$refs.content)
    if (this.$route.query?.f) {
      this.listType = JSON.parse(window.atob(decodeURIComponent(this.$route.query.f))).t
      console.log(this.listType)
    }
  },
  computed: {
    ...mapState({
      hasLogin: "hasLogin",
      lang: 'lang',
      userInfo: 'userInfo',
      unionInfo: 'unionInfo',
      isWebview: 'isWebview'
    }),
    ...mapGetters({
      roleList: 'roleList'
    }),
    langArr: function() {
      return Object.values(this.LANG_HASH).map(i => {
        return { key: i.code, value: i.lang_name };
      });
    }
  },
  methods: {
    showLangDialog() {
      this.dialog = {
        type: "lang",
        title: this.T('Language')
      };
      this.$refs.dialog.show();
      this.selectLang = this.T('Language');
    },
    changeSelectLang(lang) {
      this.selectLang = lang;
    },
    langConfilm() {
      this.changeLang(this.selectLang);
      this.$refs.dialog.close();
    },
    async showRecruitDialog() {
      if (!!this.unionInfo) {
        this.dialog = {
          type: "recruit",
          title: this.T('Recruit_Release')
        };
        this.$refs.dialog.show();
        // this.selectLang = this.T('Language');
      } else {
        this.dialog = {
          type: "toast",
          title: this.T('Error'),
          text: this.T('Unable_to_find_Alliance')
        }
        this.$refs.dialog.show();
      }
    },
    async recruitConfilm() {
      let data = await postUnion({
        unionId: this.unionInfo.legion_id,
        server_id: this.userInfo.server_id,
        server_name: this.userInfo.server_name,
        role_id: this.userInfo.role_id,
        role_name: this.userInfo.role_name
      })
      if (data.status == 200) {
        this.$refs.dialog.close();
        this.$nextTick(() => {
          this.dialog = {
            type: "toast",
            title: this.T('提示'),
            text: this.T('Posted')
          }
          this.$refs.dialog.show();
        })
      } else {
        if (data.status == 405) {
          this.$refs.dialog.close();
          // 间隔太短
          this.dialog = {
            type: "toast",
            title: this.T('Error'),
            text: this.T('Frequent_operation_please_try_again_later')
          }
          this.$refs.dialog.show();
        }
        if (data.status == 406) {
          this.$refs.dialog.close();
          // 间隔太短
          this.dialog = {
            type: "toast",
            title: this.T('Error'),
            text: this.T('No_refresh_today')
          }
          this.$refs.dialog.show();
        }
      }
    },
    showLogin() {
      this.dialog = {
        type: 'login',
        title: this.T('Login')
      }
      this.$refs.dialog.show()
    },
    onlogin() {
      this.$refs.dialog.close();
      this.$store.dispatch('upDateLogin')
    },
    logout() {
      this.util.cookie.remove('uuzu_UAUTH', '/')
      this.util.cookie.remove('uuzu_account', '/')
      this.util.cookie.remove('uuzu_UNICKNAME', '/')
      // 重置登录状态
      this.$store.dispatch('upDateLogin')
      // 重置用户信息
      this.$store.dispatch('upDateUserInfo', {})
      // 重置联盟信息
      this.$store.state.unionInfo = null
      this.roleInfo = '0'
    }
  },
  filters: {
    uppercase(val) {
      return val.toUpperCase();
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  width: 100%;
  height: 100%;
}

.page-left {
  @include bgImg("di.png");
  position: absolute;
  left: 0;
  top: 0;
  width: 2.78rem;
  height: 100%;
  padding-top: 0.8rem;

  .date {
    width: 100%;
    height: 2.2rem;
  }

  .btn-list-select {
    @include bgImg("btn-default.png");
    width: 2.94rem;
    height: 0.83rem;
    padding-right: 0.2rem;
    margin-bottom: 0.2rem;
    line-height: 0.83rem;
    text-align: center;
    font-size: $font-s;
    color: $main-color;
    cursor: pointer;

    &.active {
      @include bgImg("btn-active.png");
      color: $text-color_1;
    }
  }

  .btn-view {
    @include bgImg("btn-view.png");
    width: 2.73rem;
    min-height: 1.17rem;
    padding: .3rem .1rem;
    cursor: pointer;
    text-align: center;
  }
}

.page-right {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: 2.78rem;
  padding: 0 0.33rem 0.2rem 0.27rem;

  .top {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: 100%;
    height: 0.8rem;
  }

  .haslogin {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    text-align: right;
    .selector-item {
      display: inline-block;
      width: 2.11rem;
      height: .5rem;
      line-height: .5rem;
      margin-right: 0.27rem;
      text-align: left;
      border: solid 0.02rem #f8f5f2;
      border-radius: 0.05rem;
      box-shadow: 0 0 0 0.04rem #246bb1;
      overflow: hidden;
    }

    .logout {
      display: inline-block;
      height: .4rem;
      padding: 0 .2rem;
      margin-right: 0.27rem;
      line-height: .4rem;
      border: solid 0.02rem #f8f5f2;
      border-radius: .25rem;
      box-shadow: 0 0 0 0.04rem #246bb1;
      background: #246bb1;
      text-align: center;
      font-size: $font-xs;
    }
  }

  .webview-userinfo {
    padding: 0 .27rem;
  }

  .login-btn {
    @include bgImg("btn-login.png");
    width: fit-content;
    height: 0.54rem;
    padding: 0 .2rem;
    min-width: 1.44rem;
    margin-right: 0.27rem;
    color: #fff;
    cursor: pointer;
    text-align: center;
    line-height: .56rem;
    font-size: .4rem;
    background-size: 100% 100%;

    span {
      display: block;
      transform: scale(.7);
    }
  }

  .lang-btn {
    @include bgImg("btn-language.png");
    width: 0.64rem;
    height: 0.65rem;
    margin-right: 0.27rem;
    text-align: center;
    line-height: 0.65rem;
    font-size: $font-s;
    cursor: pointer;
    span {
      display: block;
      height: 130%;
      transform: scale(0.75);
    }
  }

  .banner {
    @include bgImg("banner.png");
    width: 100%;
    height: 1.98rem;
    background-size: cover;
  }

  .content {
    position: relative;
    flex: 1;
    height: 0;
    margin-top: 0.2rem;
  }
}

.dialog-lang {
  .lang-content {
    @include bgImg("lang-decoration.png");
    background-size: 6.27rem 0.86rem;
    background-position: center;
    background-repeat: no-repeat;
  }

  .lang-btn {
    display: flex;
    justify-content: center;
    padding: 0.15rem 0;
    cursor: pointer;
    .lang-confilm {
      @extend .common-btn;
    }
  }
}
.dialog-recruit {
  .recruit-content {
    .main-info {
      display: flex;
      font-size: 0.24rem;
      color: #ecf2f7;
      .flag {
        position: relative;
        width: 0.76rem;
        height: 0.82rem;
        margin-right: 0.35rem;
      }
      .info-wrap {
        @include ellipsis();
        width: 5rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.40rem;
        margin-right: 0.35rem;

        .nick-name {
          margin-right: 0.1rem;
        }
        .name {
          display: inline-block;
        }

        .lv-row {
          display: flex;
          justify-content: space-between;
        }
      }
    }

    .info {
      position: relative;
      width: 100%;
      padding: 0.3rem 0.05rem 0 0.05rem;
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      .addition {
        width: 25%;
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        font-size: 0.16rem;
        padding-left: 0.49rem;
        div:nth-child(1) {
          color: #b0d5f6;
        }
        div:nth-child(2) {
          color: #ecf2f7;
        }
        &:before {
          width: 0.44rem;
          height: 0.44rem;
          content: "";
          position: absolute;
          top: 0;
          left: 0;
        }
        &:nth-child(1):before {
          @include bgImg("icon-fight.png");
        }
        &:nth-child(2):before {
          @include bgImg("icon-value.png");
        }
        &:nth-child(3):before {
          @include bgImg("icon-member.png");
        }
        &:nth-child(4):before {
          @include bgImg("icon-language.png");
        }
      }
    }

    .declar {
      margin-top: 0.29rem;
      .title {
        height: 0.4rem;
        line-height: 0.4rem;
        background-color: rgba(51, 83, 120, 0.8);
        text-align: center;
      }
      .notice {
        height: 1.52rem;
        overflow: auto;
        font-size: 0.17rem;
        line-height: 0.3rem;
        padding: 0 0.3rem 0.14rem 0.14rem;
        background: rgba(#233e66, 0.2);
      }
    }
  }

  .recruit-btn {
    display: flex;
    justify-content: center;
    padding: 0.15rem 0;

    .recruit-confilm {
       @extend .common-btn;
    }
  }
}

.dialog-error {
  padding: .8rem 0;
  text-align: center;
}
</style>